import { createSelector } from 'reselect'

const selectAuth = (state: any) => state.auth

export const makeSelectToken = () =>
  createSelector(selectAuth, (authState) => authState && authState.get('token'))
